export const USER_SIGN_IN = 'USER_SIGN_IN';
export const USER_SIGN_OUT = 'USER_SIGN_OUT';
export const EMPLOYER_SIGN_UP = 'EMPLOYER_SIGN_UP';
export const CANDIDATE_SIGN_UP = 'CANDIDATE_SIGN_UP';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
